module.exports = __webpack_public_path__ + "img/kommune-1632.b46406cc.svg";